import { createFileRoute, redirect } from "@tanstack/react-router";

/** Organization types now live as a tab of `/settings/responsible-organizations`; the old address redirects (filters kept) so bookmarks work. */
export const Route = createFileRoute("/_app/settings/organization-types")({
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/settings/responsible-organizations", search: { ...(search as Record<string, unknown>), tab: "types" } as never, replace: true });
	},
});
